/**
 * One row of the BO Queue (`GET /v1/quality/reviews/awaiting-me`), as the web
 * and the phone both read it: field-force work whose decision is the reader's
 * to make now, in the order the job's workflow sets (leg 2, owner 25 Oct).
 */
export interface AwaitingReview {
  readonly reviewId: string;
  readonly jobRequestId: string;
  readonly jobNumber: string | null;
  readonly reviewStatus: string;
  readonly vendorName: string | null;
  readonly vendorCode: string | null;
  readonly painterName: string | null;
  readonly painterCode: string | null;
  /** When the field force handed the work in. */
  readonly submittedAt: string;
  /** When the vendor approved it; null while it is still his to decide. */
  readonly vendorApprovedAt: string | null;
  readonly instanceId: string;
  /** REVIEW: the vendor's level, decided on the review. WORKFLOW: a later level. */
  readonly decidesOn: 'REVIEW' | 'WORKFLOW';
}

export const AWAITING_REVIEWS_PATH = '/v1/quality/reviews/awaiting-me';
